import { Country } from './country';

enum SourceId {
    US = 2801,
    CA = 2802,
    MobileUs = 2803,
    MobileCa = 2804,
}

export { SourceId };

export function getSourceIdForCountry(country: Country): SourceId {
    return country === Country.US ? SourceId.US : SourceId.CA;
}

export function getCountryFromSourceId(sourceId: SourceId): Country {
    return sourceId === SourceId.US || sourceId === SourceId.MobileUs
        ? Country.US
        : Country.CA;
}
